// extracted by mini-css-extract-plugin
module.exports = {"video":"RenderVideo_video__3Wo0O"};